import { useQuery } from "@tanstack/react-query"

import { getPrayerTrackerReport } from "api/prayerLogApi"

export const PRAYER_TRACKER_QUERY_KEY = "prayer-tracker"

export const usePrayerTrackerReport = (params = {}, enabled = true) =>
  useQuery({
    queryKey: [PRAYER_TRACKER_QUERY_KEY, "report", params],
    queryFn: () => getPrayerTrackerReport(params),
    enabled,
    keepPreviousData: true,
  })
